import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { enumPaymentState } from '@data-layer/enums/payments/enumPaymentState';
import { enumDigitalSignState } from '@data-layer/enums/digital-signs/enumDigitalSignState';

export interface DigitalSignModel {
  id: number;
  referenceNumber: string;
  state: enumDigitalSignState;
  documentId: number;
  paymentState: enumPaymentState;
  positionOfChief?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  email?: string;
  ccEmail?: string;
}

export interface DigitalSignUpdateBody {
  email: string;
  phoneNumber: string;
  firstName: string;
  lastName: string;
  positionOfChief: string;
  ccEmail?: string;
}

@Injectable({ providedIn: 'root' })
export class DigitalSignsRepository {
  constructor(private apiService: ApiService) {}

  public list(companyId: number): Observable<DigitalSignModel[]> {
    return this.apiService.get<DigitalSignModel[]>(`${environment.url.prefixCustoms}v2/companies/${companyId}/digital-signs`);
  }

  public create(companyId: number): Observable<number> {
    return this.apiService.post<number>(`${environment.url.prefixCustoms}v2/companies/${companyId}/digital-signs`);
  }

  public getById(id: number): Observable<DigitalSignModel> {
    return this.apiService.get<DigitalSignModel>(`${environment.url.prefixCustoms}v2/digital-signs/${id}`);
  }

  /** @deprecated — no longer used in frontend. Use update() instead. */
  public updatePositionOfChief(id: number, positionOfChief: string): Observable<void> {
    return this.apiService.put<void>(
      `${environment.url.prefixCustoms}v2/digital-signs/${id}/position-of-chief`,
      JSON.stringify(positionOfChief),
    );
  }

  public update(id: number, body: DigitalSignUpdateBody): Observable<void> {
    return this.apiService.put<void>(`${environment.url.prefixCustoms}v2/digital-signs/${id}`, body);
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete<void>(`${environment.url.prefixCustoms}v2/digital-signs/${id}`);
  }
}
